import Add from './icons/Add';
import Airdrop from './icons/Airdrop';
import Bag2 from './icons/Bag2';
import BagLink from './icons/BagLink';
import Cake from './icons/Cake';
import Candle from './icons/Candle';
import Cart from './icons/Cart';
import Click from './icons/Click';
import ClipboardText from './icons/ClipboardText';
import Clock from './icons/Clock';
import Clone from './icons/Clone';
import Data from './icons/Data';
import Discount from './icons/Discount';
import Document from './icons/Document';
import DocumentDownload from './icons/DocumentDownload';
import ExportArrow from './icons/ExportArrow';
import Eye from './icons/Eye';
import Graph from './icons/Graph';
import HandTip from './icons/HandTip';
import Chat from './icons/Chat';
import ChatStar from './icons/ChatStar';
import ChevronRight from './icons/ChevronRight';
import Image from './icons/Image';
import MagicPen from './icons/MagicPen';
import MagicStar from './icons/MagicStar';
import Map from './icons/Map';
import Menu from './icons/Menu';
import MessageQuestion from './icons/MessageQuestion';
import Mobile from './icons/Mobile';
import NewFolder from './icons/NewFolder';
import Play from './icons/Play';
import Present from './icons/Present';
import Profile2Users from './icons/Profile2Users';
import Repeat from './icons/Repeat';
import Ribbon from './icons/Ribbon';
import Settings from './icons/Settings';
import Sms from './icons/Sms';
import SmsStar from './icons/SmsStar';
import SmsTracking from './icons/SmsTracking';
import Star from './icons/Star';
import TabletEdit from './icons/TabletEdit';
import Tag from './icons/Tag';
import User from './icons/User';
import UserCircle from './icons/UserCircle';
import UserEdit from './icons/UserEdit';
import UserLaptop from './icons/UserLaptop';
import Video from './icons/Video';

const ICONS = {
  add: Add,
  airdrop: Airdrop,
  bag2: Bag2,
  bagLink: BagLink,
  cake: Cake,
  candle: Candle,
  cart: Cart,
  click: Click,
  clipboardText: ClipboardText,
  clock: Clock,
  clone: Clone,
  data: Data,
  discount: Discount,
  document: Document,
  documentDownload: DocumentDownload,
  exportArrow: ExportArrow,
  eye: Eye,
  graph: Graph,
  handTip: HandTip,
  chat: Chat,
  chatStar: ChatStar,
  chevronRight: ChevronRight,
  image: Image,
  magicPen: MagicPen,
  magicStar: MagicStar,
  map: Map,
  menu: Menu,
  messageQuestion: MessageQuestion,
  mobile: Mobile,
  newFolder: NewFolder,
  play: Play,
  present: Present,
  profile2Users: Profile2Users,
  repeat: Repeat,
  ribbon: Ribbon,
  settings: Settings,
  sms: Sms,
  smsStar: SmsStar,
  smsTracking: SmsTracking,
  star: Star,
  tabletEdit: TabletEdit,
  tag: Tag,
  user: User,
  userCircle: UserCircle,
  userEdit: UserEdit,
  userLaptop: UserLaptop,
  video: Video
};

function Icon({ type, ...props }) {
  const Component = ICONS[type];

  return Component ? <Component {...props} /> : null;
}
export { Icon };
